module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_twitter.svg?8567afe2b4406fb6d009939280b26385";